import React, { Component } from "react";
import { connect } from "react-redux";

import {
    loadDownloadInfo
} from "../../modules/hiclasstv";

import WebHiClassInfo from "../../components/etc/info/WebHiClassInfo";

class WebHiClassInfoContainer extends Component {
    componentDidMount = () => {
        var infoView = document.getElementById("infoView");
        infoView.parentElement.scrollTo(0, 0);
    }

    handleSelectedFunc = ({ selectedFunc }) => {
        switch (selectedFunc) {
            case "GET_DOWNLOAD_INFO":
                this.props.loadDownloadInfo();
                break;

            default:
                break;
        }
    }

    render() {
        return (
            <div className="web-main info-area align-items-center" id="infoView">
                <WebHiClassInfo
                    currentInfoTap={this.props.currentInfoTap}
                    currentLandingPage={this.props.currentLandingPage}  // 20261105 로그인 전 menu.json 선택 페이지
                    isLoginYn={this.props.isLoginYn}                    // 20261105
                    download_info={this.props.download_info}
                    handleSelectedFunc={this.handleSelectedFunc}
                />
            </div>
        );
    }
}

export default connect(
    ({ hiclasstv, user }) => ({
        currentInfoTap      : hiclasstv.currentInfoTap,
        currentLandingPage  : hiclasstv.currentLandingPage,  // 20261105
        isLoginYn           : user.isLoginYn,                // 20261105
        download_info       : hiclasstv.download_info
    }),
    {
        loadDownloadInfo
    }
)(WebHiClassInfoContainer);